var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 107,
    viewBox: "0 0 128 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.848 55.8C122.848 70 117.048 82.8 107.748 92C98.648 101.1 86.048 106.6 72.148 106.6C58.348 106.6 45.748 101 36.548 92C27.248 82.8 21.448 70 21.448 55.8C21.448 27.7 44.148 5 72.148 5C100.148 5 122.848 27.8 122.848 55.8Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M118.449 22.5C120.713 22.5 122.549 20.66 122.549 18.4C122.549 16.13 120.713 14.3 118.449 14.3C116.184 14.3 114.349 16.13 114.349 18.4C114.349 20.66 116.184 22.5 118.449 22.5Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.449 6.50002C125.995 6.50002 127.249 5.24002 127.249 3.70002C127.249 2.15002 125.995 0.900024 124.449 0.900024C122.902 0.900024 121.649 2.15002 121.649 3.70002C121.649 5.24002 122.902 6.50002 124.449 6.50002Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.049 22.4C24.595 22.4 25.849 21.14 25.849 19.6C25.849 18.05 24.595 16.8 23.049 16.8C21.502 16.8 20.249 18.05 20.249 19.6C20.249 21.14 21.502 22.4 23.049 22.4Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.94899 76.4C8.81999 76.4 11.149 74.07 11.149 71.2C11.149 68.33 8.81999 66 5.94899 66C3.07699 66 0.748993 68.33 0.748993 71.2C0.748993 74.07 3.07699 76.4 5.94899 76.4Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107.749 29.2001V92.0001C98.649 101.1 86.049 106.6 72.149 106.6C58.349 106.6 45.749 101 36.549 92.0001V29.2001H107.749Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.406 61.2501L59.477 47.3201L54.739 52.0601L68.669 65.9901L73.406 61.2501Z",
    fill: "#02CF79"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M84.832 40.4L64.043 61.19L68.781 65.92L89.57 45.13L84.832 40.4Z",
    fill: "#02CF79"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M90.348 74.5H53.948V79.1H90.348V74.5Z",
    fill: "#D5DAE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M90.348 84.6H53.948V89.2H90.348V84.6Z",
    fill: "#D5DAE5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.449 94.8H62.849V99.4H81.449V94.8Z",
    fill: "#D5DAE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessPlaceholder);
export default __webpack_public_path__ + "static/media/success_placeholder.7c7ca3f2e0678934ce11eea2e4e83157.svg";
export { ForwardRef as ReactComponent };